import { Box, Tooltip, Typography, useTheme } from "@material-ui/core";
import React from "react";
import Text from "../../../../shared/components/Text";

export const LabelAndValueInfoRow = ({ labelTextId, value, tooltip }) => {
  const { palette } = useTheme();
  return (
    <Box
      width={"100%"}
      display={"inline-flex"}
      justifyContent={"space-between"}
      pb={1}
    >
      <Typography
        variant={"subtitle1"}
        color={"textPrimary"}
        style={{ position: "relative" }}
      >
        <Text tId={labelTextId} />
        {tooltip && (
          <Tooltip tabIndex={0} title={<Text tId={tooltip} />}>
            <i
              className="material-icons-outlined"
              style={{
                fontSize: 14,
                top: "7px",
                position: "absolute",
                marginLeft: "6px",
                color: palette.warning.main,
              }}
            >
              info
            </i>
          </Tooltip>
        )}
      </Typography>
      <Typography variant={"subtitle1"} color={"textPrimary"}>
        <strong>{value}</strong>
      </Typography>
    </Box>
  );
};
